import styled from "styled-components";
import {RouterOutletDefaultBox} from "./router-outlet.default.box";

export const RouterOutletSIBox = styled(RouterOutletDefaultBox)`
  background-image: url("${props => props.theme.assets.images.texture_png.toString()}");
`